import { FInsertFavoriteToDayplanConnectorApollo } from '@front-activerse/common-components';
import { FAddMealToFavoritesConnectorApollo } from '@front-activerse/common-components';
import { FRemoveMealFromFavoritesConnectorApollo } from '@front-activerse/common-components';
import { FFavMealsConnectorApollo } from '@front-activerse/common-components';
import { FFavMealDetailsCacheConnectorApollo } from '@front-activerse/common-components';
import FavMealsIndexContainer from './FavMealsIndexContainer';

const FavMealsIndex = () => {
  return (
    <FFavMealsConnectorApollo>
      {({ cacheHit, hasNetworkError, lastAvailableDay, ...favMealsData }) => (
        <FRemoveMealFromFavoritesConnectorApollo>
          {({ removeMealFromFavorites }) => (
            <FAddMealToFavoritesConnectorApollo>
              {({ addMealToFavorites }) => (
                <FInsertFavoriteToDayplanConnectorApollo>
                  {({ insertFavoriteToDayplan }) => (
                    <FFavMealDetailsCacheConnectorApollo>
                      {({ prefetchMealDetails }) => (
                        <FavMealsIndexContainer
                          lastAvailableDay={lastAvailableDay}
                          {...favMealsData}
                          {...{
                            removeMealFromFavorites,
                          }}
                          {...{
                            addMealToFavorites,
                          }}
                          {...{
                            insertFavoriteToDayplan,
                          }}
                          prefetchMealDetails={prefetchMealDetails}
                        />
                      )}
                    </FFavMealDetailsCacheConnectorApollo>
                  )}
                </FInsertFavoriteToDayplanConnectorApollo>
              )}
            </FAddMealToFavoritesConnectorApollo>
          )}
        </FRemoveMealFromFavoritesConnectorApollo>
      )}
    </FFavMealsConnectorApollo>
  );
};

export default FavMealsIndex;
